// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2HWkT","title":"FrontImage_title__3DvjD"};